import React from "react";
import { Box, Text, Button, Form } from "grommet";
import { useLocation, useNavigate } from "react-router-dom";
import PageMainCanvas from "../mainpage/PageMainCanvas";
import { MdExpandLess, MdLibraryBooks } from "react-icons/md";
import useBook from "../../hooks/useBook";
import useToc from "../../hooks/useToc";
import { get } from "http";
import { CaretDownFill, CaretRightFill, FormNextLink } from "grommet-icons";
import { HiUsers } from "react-icons/hi";


const PageRedbookUnit = () => {

    let location = useLocation();
    let navigate = useNavigate()
    const redbook_id = location.hash.split("#").pop() || "";
    console.log("redbook_id", redbook_id)
    const [aRedbook, setARedbook] = React.useState<any>({});
    const [tocs, setTocs] = React.useState<any>([]);
    const [tocL1s, setTocL1s] = React.useState<any>([]);
    const [ready, setReady] = React.useState<boolean>(false);

    React.useEffect(() => {
        if (redbook_id !== "") {
            console.log("redbook_id", redbook_id)
            const getRedbook = async () => {
                const res = await useBook.getBookById(redbook_id.toString());
                console.log("redbook", res)
                if (res) return res.book
            }
            const getTocs = async () => {
                const res = await useToc.getTocsByBookId(redbook_id.toString());
                console.log("tocs", res)
                if (res) return res.tocs
            }
            getRedbook().then((res) => {
                if (res) {
                    setARedbook(res);
                    getTocs().then((res) => {
                        if (res) {
                            setTocs(res);
                            // filter toc_hierarchy = 1
                            let tocL1s = res.filter((t: any) => (t.toc_hierarchy === 1));
                            setTocL1s(tocL1s);
                            setReady(true);
                        }
                    })
                }
            })
        } else {
            navigate("/redbooks")
        }
    }, [redbook_id])

    const ARedbook = (props: any) => {
        let a_book = props.book;
        return (
            <Box style={{ maxWidth: "500px", minWidth: "500px" }}
                flex={false} width='full' alignSelf='center'
                align='center' justify='center'>
                {ready && <>
                    <Box width="full" height="full" align="center" justify="center" pad="2px" border
                        background="rgba(255,255,255,0.8)" elevation="small"
                    >
                        <Text>
                            <Text size="15px">{a_book.book_title}</Text>
                            <Text size='13px' margin={{ left: '5px' }}>{a_book.numeration}</Text>
                        </Text>
                        <Text>
                            <Text size='12px'>{a_book.publisher}</Text>
                            <Text size='10px' margin={{ left: '5px' }}>{a_book.publish_date}</Text>
                        </Text>
                    </Box></>}
            </Box>
        )
    }
    const TocL1Card = (props: any) => {
        let a_toc = props.toc;
        let a_toc_title = a_toc.toc_title;
        let a_toc_id = a_toc.toc_id;
        let a_toc_h = a_toc.toc_hierarchy;

        const [openL2, setOpenL2] = React.useState<boolean>(false);
        const [tocL2s, setTocL2s] = React.useState<any>([]);
        const [readyL2, setReadyL2] = React.useState<boolean>(false);

        React.useEffect(() => {
            let tocs_2 = tocs.filter((t: any) => (t.toc_hierarchy === 2 && t.toc_upper === a_toc_id));
            setTocL2s(tocs_2);
            setReadyL2(true);
        }, [])

        const TocL2Card = (props: any) => {

        }

        return (
            <Box width="full" flex={false} align="center" justify="between" pad="10px"
                margin={{ vertical: "5px" }}
                background="rgba(255,255,255,0.7)"
                border={{ color: "rgb(200,200,200)" }}
                onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.9)" }}
                onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.7)" }}
            >
                <Box alignSelf='start' justify='between' direction="row" width='full'
                >
                    <Button plain
                        icon={openL2 ? <CaretDownFill size="20px" /> :
                            <CaretRightFill size="20px" />}
                        label={<Text size="15px">{a_toc.toc_title}
                            <Text size='10px' margin={{ left: '5px' }}>({tocL2s.length}개 조직)
                            </Text>
                        </Text>}
                        onClick={() => { setOpenL2(!openL2) }}
                    />
                    <Button plain
                        icon={<HiUsers size="18px"
                        color="rgb(200,200,200)"
                        onMouseEnter={(e)=>{e.currentTarget.style.color="black"}}
                        onMouseLeave={(e)=>{e.currentTarget.style.color="rgb(200,200,200)"}}
                        />} />
                </Box>

                {openL2 && <Box></Box>}

            </Box>
        )
    }

    return (
        <Box width="full" height="full">
            <PageMainCanvas>
                <Box direction="row" align="center" width='full'
                    style={{ minHeight: "50px", maxHeight: "50px" }}
                    focusIndicator={false}
                    onClick={() => { navigate("/redbooks") }}
                    hoverIndicator
                >
                    <MdLibraryBooks size="30px" />
                    <Text size="20px" margin={{ left: '10px' }}>직원록</Text>
                </Box>
                <Box>
                    <ARedbook book={aRedbook} />
                </Box>
                <Box height='full' overflow={"auto"} align='center' margin={{ top: "50px" }}
                    style={{ maxWidth: "1000px", minWidth: "500px" }}
                    alignSelf='center'
                >
                    {tocL1s.map((t: any) => (<TocL1Card toc={t} key={t.toc_id} />))}
                </Box>


            </PageMainCanvas>

        </Box>
    );
}

export default PageRedbookUnit;